module.exports = __webpack_public_path__ + "img/sold-out.cc3e8119.svg";